import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./auth";

function PrivateRoute({ component: Component, title, ...rest }) {
  const { authTokens } = useAuth();

  if (title === undefined)
    title = "";
  document.title = title;

  return (
    <Route
      {...rest}
      render={props =>
        authTokens() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { referer: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;